@import '~style-sheet-helpers/core.less';
@import './shared-classes.module.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/spacing.module.less';

.admin-menu-container {
  right: -@menu-button-width;
  padding: 10px;
  width: 340px;
  max-height: 500px;
}

.input-controls {
  display: flex;
}

.input-field-wrap {
  flex-grow: 2;
  input {
    line-height: 27px;
    width: 100%;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    color: @app-header--dropin-menu-input--text-color;
    padding-left: 6px;
    border: 1px solid @app-header--dropin-menu-input--border-color;
  }
}

.input-button-wrap {
  flex-grow: 1;
  text-align: left;
  button:first-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.informational {
  color: @app-header--dropin-menu-information--text-color;
  font-size: 14px;
  text-align: center;
  padding: 10px;
}

.footer-action {
  text-align: left;
  padding-top: 10px;
}

.admin-menu-dropdown {
  height: 100%;
}

.dropped-in-button {
  height: 100%;
  min-width: 40px;
  border-radius: 4px;
  background-color: @app-header--dropin-menu--background-color;
  color: @app-header--dropin-menu--text-color;
}

.dropped-in {
  display: flex;
  padding: 0 8px 0 6px;
  align-items: center;
  font-size: 20px;

  svg {
    color: @app-header--dropin-menu--fill-color;
    transform: scale(0.8);
  }
}
